export default __webpack_public_path__ + "d86fa08f613e17fc5b8b49add351a61b.png";